const getHomeofficeLabel = (value: number) => {
  if (!value) return `0 Tage`
  if (value === 1) {
    return `${value} Tag`
  } else if (value > 0) {
    return `${value} Tage`
  }
}

export default getHomeofficeLabel
